import { render, staticRenderFns } from "./LevelStageDemo.vue?vue&type=template&id=6030124a&scoped=true"
import script from "./LevelStageDemo.vue?vue&type=script&lang=js"
export * from "./LevelStageDemo.vue?vue&type=script&lang=js"
import style0 from "./LevelStageDemo.vue?vue&type=style&index=0&id=6030124a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030124a",
  null
  
)

export default component.exports